import { render } from "./FormRenderer.vue?vue&type=template&id=4ffa8194"
import script from "./FormRenderer.vue?vue&type=script&lang=js"
export * from "./FormRenderer.vue?vue&type=script&lang=js"

import "./FormRenderer.vue?vue&type=style&index=0&id=4ffa8194&lang=scss"

import exportComponent from "c:\\Clients\\VoterFly\\application\\VoterFly\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__